import { ENVIRONMENT } from "./environment"

const config = {
	DEVELOPMENT: {
		url: 'https://dev.frankwatching.com/wp-json/cams/v1/search'
	},
	ACCEPTANCE: {
		url: 'https://acc.frankwatching.com/wp-json/cams/v1/search'
	},
	PRODUCTION: {
		url: 'https://www.frankwatching.com/wp-json/cams/v1/search'
		// url: 'https://acc.frankwatching.com/wp-json/cams/v1/search'
	}
};

export const postSearch = config[ENVIRONMENT];


// WEBPACK FOOTER //
// ./src/config/postSearch.js